import { DataGridCellType, IControlDataGridColumn } from '../../DataGrid/entities';
import { IControlProperties } from '../../../entities/IControlProperties';
import { cellTypeToControlType } from './cellTypeToControlType';
import IconSearch from '@bimser/icons/16/search';

export function getBaseColumnData(
	type: DataGridCellType
): IControlDataGridColumn<IControlProperties> {
	return {
		caption: {
			'tr-TR': 'Temp',
			'en-US': 'Temp'
		},
		width: 100,
		align: 'left',
		wordWrapEnabled: false,
		visible: true,
		sorting: {
			index: 0,
			order: 'asc',
			enabled: true
		},
		editingEnabled: true,
		cellType: type,
		filtering: {
			enabled: false,
			operation: 'Contains',
			value: null
		},
		name: 'Tempitem',
		summaryTypes: [],
		control: {
			controlType: cellTypeToControlType(type),
			controlId: '',
			name: ''
		},
		defaultValue: null,
		isPrimaryKey: false,
		autoIncrement: false,
		actionButtonProps: {
			name: '',
			text: {},
			title: {},
			icon: IconSearch.info.name,
			typeName: 'CreateFormArgs',
			args: null,
			visible: true
		}
	};
}
